import React, {forwardRef} from "react";
// @material-ui/core components
import { makeStyles, FormControlLabel, FormControl, FormLabel, Radio, RadioGroup } from "@material-ui/core";
// core components
import GridItem from "components/Grid/GridItem.js";

const styles = {
  root:{
    border: '1px solid blue',
    borderRadius: 3,
    padding: 3,
    paddingLeft: 7,
    width: '95%',
  },
  small:{
    border: '1px solid blue',
    borderRadius: 3,
    width: '95%',
    height: '90%',
    marginBottom: 0,
    padding: 0,

  },
  horizontal: {
    flexFlow: 'row nowrap',
    justifyContent: 'center',
  },
  vertical: {
    justifyContent: 'center',
    height: 100,
  },
  formLabel: {
    marginBottom: 1,
    fontSize: 14,
  },
  fcLabel:{
    marginLeft: 1,
  },
  radio: {
    border: '7px solid rgb(75, 125, 200)',
    backgroundColor: 'white',
    borderRadius: '50%',
    marginLeft: 1,
    '&:before': {
      display: 'block',
      width: 7,
      height: 7,
      content: '""',
    },
  }
};

const useStyles = makeStyles(styles);

export const RadioInput = forwardRef((props, ref) => {
  const classes = useStyles();
  const small = props.small
  const horizontal = props.horizontal
  const vertical = props.vertical
  const fieldsize = props.fieldsize ? props.fieldsize : 12

  const choices = props.options.map(option => (
    <FormControlLabel className={classes.fcLabel} key={option}
                      value={option} label={option} inputRef={ref}
                      control={<Radio checkedIcon={<span className={classes.radio}/>} />}/>
  ))
  return (
    <GridItem xs={12} sm={12} md={fieldsize}>
      <FormControl component="fieldset" className={`${small? classes.small : classes.root}`}>
          <FormLabel component="legend" className={classes.formLabel}>{props.label}</FormLabel>
          <RadioGroup className={`${vertical && classes.vertical} ${horizontal && classes.horizontal}`} {...props}>
            {choices}
          </RadioGroup>
      </FormControl>
    </GridItem>
    )
})
